import React, { Component } from "react";

import { Redirect } from 'react-router-dom';
import { Layout } from 'antd';
import Login from "../../containers/Login";
import Core from "../../Core.js";
import history from "../../history";
import { getSocket, initSocket } from '../../socket';

import './index.scss';

export default class LoginPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: null
        };
        this.button = React.createRef();
        this.handleLoggedIn = this.handleLoggedIn.bind(this);
    }

    componentDidMount() {

    }

    componentDidUpdate(prevProps, prevState, snapshot) {

    }

    handleLoggedIn(data) {
        Core.onLogged();
        this.setState({ data });
        if(Core.data().login &&  getSocket() == null) {
          initSocket(Core.data().login);
        }
    }

    render() {
        const { match } = this.props;
        const { params } = match;
        const { data } = this.state;
        let main = null;
        if (data) {
            if(this.props.location.search === '?materiais-de-apoio'){
              return <Redirect to="/materiais-de-apoio" />;

            } else if (Core.data().config.private == true && Core.data().config.no_home == false) {
                return <Redirect to="/" />;

            } else {
                return <Redirect to="/player" />;

            }
        }
        return (
            <Layout className="login-page">
                <main>
                  <Login token={params.token} onLoggedIn={this.handleLoggedIn} />
                </main>
            </Layout>
        );
    }
}
